import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  Input,
  OnInit,
  SkipSelf,
} from '@angular/core';
import {
  ControlContainer,
  FormGroupDirective,
  ValidationErrors,
} from '@angular/forms';
import { InfoOption } from '@app/forms/subscription/components/info/info.component';
import { FundsOriginList } from '@app/forms/subscription/definition/interface/subscription';
import { SubscriptionFacadeService } from '@app/forms/subscription/services/subscription-facade.service';
import { delay } from 'rxjs';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

@UntilDestroy()
@Component({
    selector: 'assessment-assets',
    templateUrl: './assessment-assets.component.html',
    styleUrls: ['./assessment-assets.component.scss'],
    viewProviders: [
        {
            provide: ControlContainer,
            useFactory: (container: ControlContainer) => container,
            deps: [[new SkipSelf(), ControlContainer]],
        },
    ],
    standalone: false
})
export class AssessmentAssetsComponent implements OnInit, AfterViewInit {
  @Input() derrors: any = false;
  error: ValidationErrors = null;
  optionInfo1: InfoOption = {
    icon: 'warning',
    backgroundColor: '#fae4e4',
    iconColor: '#a00d0d',
    textColor: '#a00d0d',
  };
  optionInfo2: InfoOption = {
    icon: 'warning',
    backgroundColor: '#FFF9F0',
    iconColor: '#876A33',
    textColor: '#876A33',
  };
  constructor(
    private controlContainer: FormGroupDirective,
    private cd: ChangeDetectorRef,
    private subscriptionFacade: SubscriptionFacadeService,
  ) {}
  ngAfterViewInit(): void {
    this.cd.detectChanges();
  }
  get form() {
    return this.controlContainer.form;
  }

  ngOnInit() {
    this.form
      .get('distributionAssets')
      // delay to wait for the form to be initialized (to avoid errors Error: ExpressionChangedAfterItHasBeenCheckedError))
      .valueChanges.pipe(untilDestroyed(this), delay(0))
      .subscribe((data: FundsOriginList[]) => {
        if (data.length > 0) {
          let sum = 0;

          sum = data.reduce((acc, curr) => {
            sum += Number(curr.distribution);
            return sum;
          }, 0);
          if (sum != 100) {
            this.form.get('distributionAssets').setErrors({
              incorrect: true,

              message: 'La somme des parts réalisées doit être égale à 100%',
            });
          } else {
            this.form.get('distributionAssets').setErrors(null);
          }
        }
        this.error = this.form.get('distributionAssets').errors;
      });
    this.cd.detectChanges();
  }
}
